// ============================================================================
// MODIFICATION : Attendre que le DOM soit complètement chargé
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
  var relatedProductElement = document.querySelector('#related_product_id');
  
  if (!relatedProductElement) {
    console.log('[Related Products] Element not found on this page');
    return;
  }
  
  var productidvalue = relatedProductElement.getAttribute("data-id");
  var metafieldValue = '';
  
  checkProductListPage(productidvalue);
});
// ============================================================================

async function getMetafieldValue(productidvalue) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: 'https://www.peterandmay.com/api/2024-10/graphql.json',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      headers: {
        'X-Shopify-Storefront-Access-Token': '622e264bc60874859baadd81bd3a0ada',
        'Access-Control-Allow-Origin': '*',
        'Accept-Language': 'fr-FR',
      },
      data: JSON.stringify({
        query: `
          {
            product(id: "gid://shopify/Product/${productidvalue}") {
              metafield(key: "pastillecouleur", namespace: "custom") {
                value
              }
            }
          }`
      }),
      cache: false,
      success: function(response) {
        const metafieldValue = response?.data?.product?.metafield?.value;
        if (metafieldValue) {
          resolve(metafieldValue);
        } else {
          console.error('Metafield is missing or null');
          reject('Metafield is missing or null');
        }
      },
      error: function(xhr, status, error) {
        console.error('AJAX Error:', error);
        reject(error);
      }
    });
  });
}

// ============================================================================
// Formater le prix selon la devise
// ============================================================================
function formatPrice(amount, currencyCode) {
  var price = parseFloat(amount).toFixed(2);
  
  if (currencyCode === 'EUR') {
    return '€' + price.replace('.', ',');
  } else if (currencyCode === 'USD') {
    return '$' + price;
  } else if (currencyCode === 'GBP') {
    return '£' + price;
  } else if (currencyCode === 'CHF') {
    return 'CHF ' + price;
  } else {
    return currencyCode + ' ' + price;
  }
}
// ============================================================================


function checkProductListPage(productidvalue) {
  getMetafieldValue(productidvalue)
  .then(metafieldValue => {
    
    // ============================================================================
    // Récupérer le pays et la devise active
    // ============================================================================
    var activeCurrency = 'EUR';
    var countryCode = 'FR';
    
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        activeCurrency = window.Shopify.currency.active;
      }
      if (window.Shopify && window.Shopify.country) {
        countryCode = window.Shopify.country;
      }
    } catch(e) {
      console.log('[Related Products] Could not get market context');
    }
    
    console.log('[Related Products] Market context - Country:', countryCode, 'Currency:', activeCurrency);
    // ============================================================================
    
    $.ajax({
      url: 'https://www.peterandmay.com/api/2024-10/graphql.json',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      headers: {
        'X-Shopify-Storefront-Access-Token': '622e264bc60874859baadd81bd3a0ada',
        'Access-Control-Allow-Origin': '*',
        'Accept-Language': 'fr-FR',
      },
      
      // ============================================================================
      // MODIFICATION : Utiliser @inContext pour spécifier le marché
      // ============================================================================
      data: JSON.stringify({
        query: `
          query @inContext(country: ${countryCode}) {
            products(first: 30, query: "metafield:'custom.pastillecouleur':'${metafieldValue}'") {
              edges {
                node {
                  handle
                  id
                  title
                  productType
                  metafield(key: "pastillecouleur", namespace: "custom") {
                    key
                    namespace
                    value
                  }
                  images(first: 1) {
                    nodes {
                      altText
                      url
                    }
                  }
                  priceRange {
                    maxVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  variants(first: 3, reverse: true) {
                    nodes {
                      id
                      image {
                        url(transform: {maxWidth: 600, crop: CENTER})
                        altText
                      }
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          } `
      }),
      // ============================================================================
      
      cache: false,
      success: function(response) {
        console.log('[Related Products] API Response received');
        
        var langHtml = document.querySelector("html"); 
        if(langHtml.getAttribute("lang") == "fr") {
          store_language = "";
        }else if(langHtml.getAttribute("lang") == "en"){
          store_language = "en/";
        }
        var productlist = '<ul class="grid product-grid grid--4-col-desktop grid--2-col-tablet-down" role="list">';
        
        const filteredProducts = response.data.products.edges.filter(product => {
            const metafieldValueFromAPI = product.node.metafield?.value?.trim().toLowerCase();
            const normalizedMetafieldValue = metafieldValue.trim().toLowerCase();
            return metafieldValueFromAPI === normalizedMetafieldValue;
        }).slice(0, 4);
        
        console.log('[Related Products] Filtered products count:', filteredProducts.length);
        
        filteredProducts.forEach(function(product) {
          var productType = product.node.productType;
          var productPrice = "";
          
          if(productType != "OPTICAL" && productType != "OPTIQUE"){
            var priceAmount = product.node.priceRange.maxVariantPrice.amount;
            var priceCurrency = product.node.priceRange.maxVariantPrice.currencyCode;
            productPrice = formatPrice(priceAmount, priceCurrency);
            
            console.log('[Related Products] Product:', product.node.title, '- Price:', priceAmount, priceCurrency);
          }
          
          productlist += '<li class="grid__item "><div class="card-wrapper product-card-wrapper underline-links-hover">';
          productlist += '<div class="card card--standard card--media" style="--ratio-percent:100%;"><div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100%;">';
          productlist += '<a href="/' + store_language + 'products/'+ product.node.handle + '">';
          productlist += '<div class="card__media"><div class="media media--transparent media--hover-effect">';
              product.node.images.nodes.forEach(function(image, keys) {
                  productlist += '<img srcset="'+image.url+'&width=165 165w, '+image.url+'&width=360 360w, '+image.url+'&width=533 533w, '+image.url+'&width=720 720w, '+image.url+'&width=940 940w, '+image.url+'&width=1066 1066w, '+image.url+'&width=4000 4000w" src="'+image.url+'" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="'+ product.node.title + '" class="main-product-image first-image motion-reduce" loading="lazy" width="4000" height="5647">';
              });
          productlist += '</div></div></a>';
          productlist += '<div class="card__content"><div class="card__information"><h3 class="card__heading ">';
          productlist += '<a href="/' + store_language + 'products/'+ product.node.handle + '" class="full-unstyled-link">'+ product.node.title + '</a></h3>';
          productlist += '</div></div></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5">';
          productlist += '<a href="/' + store_language + 'products/'+ product.node.handle + '" class="full-unstyled-link">'+ product.node.title +'</a></h3>';
          productlist += '<div class="card-information test1"><span class="caption-large light"></span><div class="price "><div class="price__container"><div class="price__regular">';
          productlist += '<span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">'+productPrice+'</span></div>';
          productlist += '<div class="price__sale"><span class="visually-hidden visually-hidden--inline">Regular price</span><span><s class="price-item price-item--regular">'+productPrice+'</s></span><span class="visually-hidden visually-hidden--inline">Sale price</span><span class="price-item price-item--sale price-item--last">'+productPrice+'</span>';
          productlist += '</div></div></div></div></div></div></div></div></li>';
        });
        
        productlist += '</ul>'; 
        $('#related_products_container').html(productlist);
        
        console.log('[Related Products] Products displayed successfully');
      },
      error: function(xhr, status, error) {
        console.error('[Related Products] AJAX Error:', error);
        console.error('[Related Products] Response:', xhr.responseText);
      }
    });
  })
  .catch(error => {
    console.error('[Related Products] Error fetching metafield value:', error);
  });
}